import { SimulationSettings, defaultSimulationSettings } from '../types/simulation';

class SimulationService {
  private static instance: SimulationService;
  private settings: SimulationSettings;

  private constructor() {
    this.settings = { ...defaultSimulationSettings };
  }

  public static getInstance(): SimulationService {
    if (!SimulationService.instance) {
      SimulationService.instance = new SimulationService();
    }
    return SimulationService.instance;
  }

  public getSettings(): SimulationSettings {
    return { ...this.settings };
  }

  public updateSettings(settings: Partial<SimulationSettings>): void {
    this.settings = {
      ...this.settings,
      ...settings
    };
  }

  public reset(): void {
    this.settings = { ...defaultSimulationSettings };
  }
}

export const simulationService = SimulationService.getInstance();